import React from 'react';
import './PocTypePage.scss';

export type InitiationStep =
  | 'step1'
  | 'step2'
  | 'step3'
  | 'step4'
  | 'step5'
  | 'review'
  | 'complete';

const INITIATION_STEPS: { id: InitiationStep; label: string }[] = [
  { id: 'step1', label: 'Step 1' },
  { id: 'step2', label: 'Step 2' },
  { id: 'step3', label: 'Step 3' },
  { id: 'step4', label: 'Step 4' },
  { id: 'step5', label: 'Step 5' },
  { id: 'review', label: 'Review and Submit' },
];

type InitiationShellProps = {
  activeStep: InitiationStep;
  /** Gate / complete pages may hide the step strip. */
  showSteps?: boolean;
  children: React.ReactNode;
};

/**
 * Shared Initiation chrome: phase rail + step nav.
 * Keeps labels/step count in one place so pages cannot drift.
 */
const InitiationShell: React.FC<InitiationShellProps> = ({
  activeStep,
  showSteps = true,
  children,
}) => {
  return (
    <div className="initiation">
      <aside className="initiation__phases" aria-label="PoC phases">
        <div className="initiation__phase initiation__phase--active">
          <span className="initiation__phase-num">1</span>
          <span>Initiation</span>
        </div>
        <div className="initiation__phase initiation__phase--disabled">
          <span className="initiation__phase-num">2</span>
          <span>Preparation</span>
        </div>
        <div className="initiation__phase initiation__phase--disabled">
          <span className="initiation__phase-num">3</span>
          <span>Running</span>
        </div>
        <div className="initiation__phase initiation__phase--disabled">
          <span className="initiation__phase-num">4</span>
          <span>Evaluation</span>
        </div>
      </aside>

      <div className="initiation__main">
        {showSteps ? (
          <nav className="initiation__steps" aria-label="Initiation steps">
            {INITIATION_STEPS.map((step) => (
              <span
                key={step.id}
                className={
                  'initiation__step' +
                  (step.id === activeStep ? ' initiation__step--active' : '')
                }
              >
                {step.label}
              </span>
            ))}
          </nav>
        ) : null}
        {children}
      </div>
    </div>
  );
};

export default InitiationShell;
